export enum VirtualReferenceType {
  /**
   * Codice della riga corrente
   */
  RowCode = 'rowCode',
}
